import 'gsap';
import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Components from '@vaersaagod/tools/Components';
import Animator from './modules/Animator';
import Navigator from './modules/Navigator';
import './lib/polyfills';
import lazySizes from './lib/lazysizes';

/*
*   Bootstrap app
*
 */
const init = () => {
    Viewport.init();
    Viewport.releaseTabbing();
    Components.init();
    Animator.init();
    Navigator.init();
    lazySizes.init();
    
    // Scroll link handler
    $('body').on('click', '[data-scroll-anchor-link]', e => {
        e.preventDefault();
        const $link = $(e.triggerTarget);
        const id = $link.attr('href');

        if (id !== '') {
            const $target = $(id);

            if ($target.length > 0) {
                Viewport.scrollTo($target.nodes[0], {
                    duration: 1000,
                    easing: (t, b, c, d) => {
                        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
                        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
                    }
                });
            }
        }
    });

};

require('doc-ready')(() => {
    if (ENV === 'production') {
        init();
    } else {
        // Dev mode; check for styles before booting
        // Don't worry chief – this code will be stripped out of your production build <3
        const checkCSS = () => {
            if (getComputedStyle(document.body).boxSizing !== 'border-box') {
                requestAnimationFrame(checkCSS);
                return;
            }
            init();
        };
        checkCSS();
    }
});



// WEBPACK FOOTER //
// ./src/js/main.js